import PropTypes from "prop-types";
import { LuX, LuTriangleAlert } from "react-icons/lu";

export default function FiniquitoErrorModal({ onClose, errores, siniestroRef }) {
  return (
    <div
      className="fixed inset-0 z-50 overflow-y-auto bg-black/50 backdrop-blur-sm"
      aria-labelledby="finiquito-error-modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="flex items-center justify-center min-h-screen px-4 text-center">
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
          &#8203;
        </span>

        <div className="relative inline-block w-full max-w-md p-7 overflow-hidden text-left align-middle transition-all transform bg-white border-2 shadow-xl outline-none sm:my-8 rounded-2xl border-red-400">

          {/* Header */}
          <div className="flex items-start justify-between mb-5">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-[3px] border-red-400">
                <LuTriangleAlert className="text-red-500" size={20} />
              </div>
              <div>
                <p id="finiquito-error-modal-title" className="text-lg font-semibold text-gray-800">
                  No se puede generar el finiquito
                </p>
                {siniestroRef && (
                  <p className="text-sm text-gray-500">
                    Ref. {siniestroRef}
                  </p>
                )}
              </div>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="flex items-center justify-center p-1.5 text-gray-400 transition-colors duration-200 bg-transparent rounded-full hover:bg-gray-100"
              aria-label="Cerrar modal"
            >
              <LuX size={22} />
            </button>
          </div>

          {/* Body */}
          <div className="mb-5">
            <p className="text-sm text-gray-600 mb-3">
              Los siguientes campos son obligatorios para generar el documento y están vacíos:
            </p>
            <ul className="space-y-2">
              {errores.map((e) => (
                <li
                  key={e.campo}
                  className="flex items-center gap-2 px-3 py-2 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700"
                >
                  <LuTriangleAlert size={14} className="flex-shrink-0" />
                  <span className="font-semibold">{e.etiqueta}</span>
                </li>
              ))}
            </ul>
            <p className="text-xs text-gray-400 mt-4">
              Edita el siniestro y completa los campos indicados antes de generar el finiquito.
            </p>
          </div>

          {/* Footer */}
          <div className="flex justify-end pt-2">
            <button
              type="button"
              onClick={onClose}
              className="h-10 px-5 text-sm font-semibold text-white transition-colors duration-150 bg-red-500 border border-red-500 rounded-xl hover:bg-red-600"
            >
              Entendido
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}

FiniquitoErrorModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  errores: PropTypes.arrayOf(
    PropTypes.shape({
      campo: PropTypes.string,
      etiqueta: PropTypes.string,
    })
  ).isRequired,
  siniestroRef: PropTypes.string,
};